import React from "react";
import firebase from "firebase";
import axios from "axios";
import {storage} from "../firebase";

//When student finishes recording, this function will add the recording name (EX: recording.mp3), assignment number, and todays date
export function SaveRecordingData(classLevel, page, blob, assignmentNum) {
    let promise = new Promise((resolve)=>{
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {

                //Creates correct date HST
                let date = new Date();
                let AMPM = "AM";
                let minutes = date.getMinutes();
                if(date.getHours() >= 12){
                    AMPM = "PM";
                }
                let hours = date.getHours();
                if (hours >= 12) {
                    hours -= 12;
                }
                if (hours == 0) {
                    hours = 12;
                }

                if(minutes < 10){
                    minutes = '0' + minutes
                }
                let newDate = date.getMonth() + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + hours + ':' + minutes + AMPM;


                const name = user.email.split('@')[0];

                //This may be unnecessary code
                const fd = new FormData();
                fd.append('audio-file', blob.blob);

                //uploading sounds to firebase
                const uploadTask = storage.ref(`students/studentAudio/${name}_${classLevel}_${page}_${assignmentNum}.mp3`).put(blob.blob);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("students/studentAudio")
                            .child(`${name}_${classLevel}_${page}_${assignmentNum}.mp3`)
                            .getDownloadURL()
                            .then(url => {
                                console.log(url)
                            })
                            .catch(e => console.log(e))
                    }
                );
                let studentEntry = {email: user.email, assignmentNum: [], soundFileName: [], date:[]};
                let email = user.email;
                let studentData;
                let studentIDRef;
                let found = false;
                let assignmentNames = [];

                //Then upload the student data, referring to the sound name given in uploadTask before this
                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/' + page + '.json');
                studentFile.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        studentData = res.data;
                        for (let i = 0; i < studentData.length; i++) {
                            if (email === studentData[i].email) {
                                studentIDRef = i;
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            studentEntry.assignmentNum.push(assignmentNum);
                            studentEntry.soundFileName.push(`${name}_${classLevel}_${page}_${assignmentNum}.mp3`);
                            studentEntry.date.push(newDate);
                            studentData.push(studentEntry)
                            const JSONobj = JSON.stringify(studentData);
                            const blobObj = new Blob([JSONobj], {type: "application/json"});
                            const uploadTask = storage.ref('students/10' + classLevel + '/' + page + '.json').put(blobObj);
                            uploadTask.on(
                                "state_changed",
                                () => {
                                },
                                error => {
                                    console.log(error)
                                },
                                () => {
                                    storage
                                        .ref('students/10' + classLevel)
                                        .child('quizData.json')
                                        .getDownloadURL()
                                        .then(url => {
                                                console.log(url);
                                                resolve(true)
                                            }
                                        )
                                        .catch(e => console.log(e));
                                }
                            )
                        } else {
                            for(let i = 0; i < studentData[studentIDRef].assignmentNum.length; i++){
                                if(studentData[studentIDRef].assignmentNum[i] === assignmentNum){
                                    studentData[studentIDRef].assignmentNum.splice(i, 1);
                                    studentData[studentIDRef].soundFileName.splice(i, 1);
                                    studentData[studentIDRef].date.splice(i, 1)
                                }
                            }
                            studentData[studentIDRef].assignmentNum.push(assignmentNum);
                            studentData[studentIDRef].soundFileName.push(`${name}_${classLevel}_${page}_${assignmentNum}.mp3`);
                            studentData[studentIDRef].date.push(newDate);
                            const JSONobj = JSON.stringify(studentData);
                            const blobObj = new Blob([JSONobj], {type: "application/json"});
                            const uploadTask = storage.ref('students/10' + classLevel + '/' + page + '.json').put(blobObj);
                            uploadTask.on(
                                "state_changed",
                                () => {
                                },
                                error => {
                                    console.log(error)
                                },
                                () => {
                                    storage
                                        .ref('students/10' + classLevel)
                                        .child('quizData.json')
                                        .getDownloadURL()
                                        .then(url => {
                                                console.log(url);
                                                resolve(true)
                                            }
                                        )
                                        .catch(e => console.log(e));
                                }
                            )
                        }

                    });


            }
        })
    })
    return promise;
}
